import { render, staticRenderFns } from "./PapirEditor.vue?vue&type=template&id=d1160ab6&"
import script from "./PapirEditor.vue?vue&type=script&lang=js&"
export * from "./PapirEditor.vue?vue&type=script&lang=js&"
import style0 from "./PapirEditor.vue?vue&type=style&index=0&id=d1160ab6&prod&lang=scss&"
import style1 from "./PapirEditor.vue?vue&type=style&index=1&id=d1160ab6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports